import { render, staticRenderFns } from "./RecLtaDataFile3.vue?vue&type=template&id=2da5d545&"
import script from "./RecLtaDataFile3.vue?vue&type=script&lang=js&"
export * from "./RecLtaDataFile3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports